<template>
<div>
  <div class="container">
    <div class="row">
      <div class="d-flex mb-5 w-100">
        <div class="col-lg-6 pl-5 font-leadin">
          <h2>WORK</h2>
          <p>We create compelling solutions to exceed your brand and business goals.</p>
        </div>
        <div class="col-lg-6 d-flex w-100 h-100 justify-content-center align-items-center">
          <a class="btn btn-almost-black-outline btn-lg" href="#filter" data-toggle="collapse" data-target="#filter" aria-expanded="false" aria-controls="filter" @click="togglefiltersOpen">Filter results<i class="ml-3 fal fa-chevron-down" v-if="!filtersOpen"></i><i class="ml-3 fal fa-chevron-up" v-if="filtersOpen"></i></a>
        </div>
      </div>
    </div>
  </div>
  <div class="collapse w-100" id="filter" app-call="app.projects.navigation">
    <div class="section align-items-center d-flex bg-dark-gray">
      <div class="container">
        <div class="row">
          <div class="col-xl-12">
            <div class="row mb-36">
              <!-- <div class="align-items-center d-flex">
                            <button class="btn" @click="toggleShowSearchText()"><i class="fal fa-search fz-24"></i></button>
              </div>-->
              <div class="align-items-center d-flex col-xl-7 mx-auto">
                <div class="input-group color-dark-gray px-2 animated fadeIn display-inline-block">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search Projects"
                    aria-label="Search Projects"
                    v-model="searchString"
                  />
                  <div class="input-group-append">
                    <button class="btn btn-nelson-blue" type="button" @click="searchPosts">
                      <i class="fal fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <p class="color-nelson-blue">PRACTICES</p>
                <ul class="list-unstyled">
                  <li class="mb-8">
                    <a href @click.stop.prevent="setTerm('architectural-implementation','Architectural Implementation')">Architectural Implementation</a>
                  </li>
                  <li class="mb-8">
                    <a href @click.stop.prevent="setTerm('asset-strategy','Asset Strategy')">Asset Strategy</a>
                  </li>
                  <li class="mb-8">
                    <a href @click.stop.prevent="setTerm('civic-community-justice','Civic, Community, & Justice')">Civic, Community, & Justice</a>
                  </li>
                  <li class="mb-8">
                    <a href @click.stop.prevent="setTerm('healthcare','Healthcare')">Healthcare</a>
                  </li>
                  <li class="mb-8">
                    <a href @click.stop.prevent="setTerm('higher-education','Higher Education')">Higher Education</a>
                  </li>
                </ul>
              </div>
              <div class="col">
                <p class="color-nelson-blue">&nbsp;</p>
                <ul class="list-unstyled">
                  <li class="mb-8">
                    <a href @click.stop.prevent="setTerm('hospitality','Hospitality')">Hospitality</a>
                  </li>
                  <li class="mb-8">
                    <a href @click.stop.prevent="setTerm('industrial','Industrial')">Industrial</a>
                  </li>
                  <li class="mb-8">
                    <a href @click.stop.prevent="setTerm('mixed-use','Mixed-Use')">Mixed-Use</a>
                  </li>
                  <li class="mb-8">
                    <a href @click.stop.prevent="setTerm('retail','Retail')">Retail</a>
                  </li>
                  <li class="mb-8">
                    <a href @click.stop.prevent="setTerm('workplace','Workplace')">Workplace</a>
                  </li>
                </ul>
              </div>
              <div class="col">
                <p class="color-nelson-blue">SERVICES</p>
                <ul class="list-unstyled">
                  <li class="mb-8">
                    <a href @click.stop.prevent="setTerm('design-visualization','Design Visualization')">Design Visualization</a>
                  </li>
                  <li class="mb-8">
                    <a href @click.stop.prevent="setTerm('architecture','Architecture')">Architecture</a>
                  </li>
                  <li class="mb-8">
                    <a href @click.stop.prevent="setTerm('brand-communications','Brand Communication')">Brand Communications</a>
                  </li>
                  <li class="mb-8">
                    <a href @click.stop.prevent="setTerm('consulting-workplace-services','Consulting & Workplace Service')">Consulting & Workplace Services</a>
                  </li>
                </ul>
              </div>
              <div class="col">
                <p class="color-nelson-blue">&nbsp;</p>
                <ul class="list-unstyled">
                  <li class="mb-8">
                    <a href @click.stop.prevent="setTerm('environmental-graphic-design','Environmental Graphic Design')">Environmental Graphic Design</a>
                  </li>
                  <li class="mb-8">
                    <a href @click.stop.prevent="setTerm('interior-design','Interior Design')">Interior Design</a>
                  </li>
                  <li class="mb-8">
                    <a href @click.stop.prevent="setTerm('strategy-insights','Strategy & Insights')">Strategy & Insights</a>
                  </li>
                  <li class="mb-8">
                    <a href @click.stop.prevent="setTerm('sustainable-design','Sustainable Design')">Sustainable Design</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="row mt-24">
              <button
                class="btn btn-nelson-blue btn-sm mx-auto"
                @click.stop.prevent="setTerm('all', 'All')"
              >Show All</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div>
    <div class="container"></div>
  </div>
  <div class="sr-alert sr-only" role="alert" v-html="srAlert"></div>
</div>
</template>
<script>
export default {
  created() {
    // console.info("projects1 created");
  },
  mounted() {
    // console.log('projects mounted');
  },
  methods: {
    setTerm: function(slug, heading) {
      app.projects.projectsApp.setTerm(slug, heading);
      let $this = this;
      this.srAlert = "";
      setTimeout(function(){
        $this.srAlert = "Projects have been updated";
        let $target = document.querySelectorAll(".section-projects .project-item:first-child a:first-child");
        $target[0].focus();
      },500);
    },
    searchPosts: function() {
      app.projects.projectsApp.searchPosts(this.searchString);
      let $this = this;
      this.srAlert = "";
      setTimeout(function(){
        $this.srAlert = "Projects have been updated";
        let $target = document.querySelectorAll(".section-projects .project-item:first-child a:first-child");
        $target[0].focus();
      },500);
    },
    toggleShowSearchText: function() {
      this.showSearchText = !this.showSearchText;
    },
    togglefiltersOpen: function() {
        this.filtersOpen = !this.filtersOpen;
    }
  },
  data: {
    showSearchText: false,
    searchString: "",
    filtersOpen: false,
    srAlert: ""
  }
};
</script>
